import get from 'lodash/get';
import map from 'lodash/map';
import pick from 'lodash/pick';
import keysIn from 'lodash/keysIn';
import flatMap from 'lodash/flatMap';
import find from 'lodash/find';
import upperFirst from 'lodash/upperFirst';

const ALL_STATES = {
  id: 'ALL_STATES',
  title: 'All States',
  items: {
    any: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/states/vic',
        title: 'Victoria',
        omnitureItemId: 'all-states-victoria',
        description: 'Explore commercial real estate in Australia\'s fastest growing state',
        searchLocations: [
          'VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/states/nsw',
        title: 'New South Wales',
        omnitureItemId: 'all-states-new-south-wales',
        description: 'Find commercial property in Australia\'s most populous state',
        searchLocations: [
          'NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/states/qld',
        title: 'Queensland',
        omnitureItemId: 'all-states-queensland',
        description: 'Browse commercial real estate in Australia\'s second largest state',
        searchLocations: [
          'QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/states/wa',
        title: 'Western Australia',
        omnitureItemId: 'all-states-western-australia',
        description: 'Explore commercial properties Australia\'s biggest state',
        searchLocations: [
          'WA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/states/sa',
        title: 'South Australia',
        omnitureItemId: 'all-states-south-australia',
        description: 'Search for commercial properties in Australia\'s central southern region',
        searchLocations: [
          'SA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/states/tas',
        title: 'Tasmania',
        omnitureItemId: 'all-states-tasmania',
        description: 'Browse commercial premises in Australia\'s only island state',
        searchLocations: [
          'TAS',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/states/act',
        title: 'Australian Capital Territory',
        omnitureItemId: 'all-states-australian-capital-territory',
        description: 'Discover commercial real estate in the national capital of Australia',
        searchLocations: [
          'ACT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/states/nt',
        title: 'Northern Territory',
        omnitureItemId: 'all-states-northern-territory',
        description: 'Search for commercial premises in the central and northern region of Australia',
        searchLocations: [
          'NT',
        ],
      },
    ],
  },
};
const POPULAR_AREAS = {
  id: 'POPULAR_AREAS',
  title: 'Popular Areas',
  items: {
    any: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-metro/VIC_Metro_Northern-Melbourne_Brunswick',
        title: 'Northern Melbourne',
        omnitureItemId: 'popular-areas-northern-melbourne',
        description: 'Includes Campbelfield, Brunswick, Thomastown.',
        searchLocations: [
          'Melbourne - Northern Region, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-metro/nsw_metro_innerwestsydney_balmain',
        title: 'Inner West Sydney',
        omnitureItemId: 'popular-areas-inner-west-sydney',
        description: 'Includes Balmain, Camperdown, Marrickville.',
        searchLocations: [
          'Inner West, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-reginal/VIC_Regional_Western-Region',
        title: 'Western Victoria',
        omnitureItemId: 'popular-areas-western-victoria',
        description: 'Includes Melton, Ballarat, Grampians.',
        searchLocations: [
          'Western Region, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-regional/nsw_regional_centralcoast_gosford',
        title: 'Central Coast',
        omnitureItemId: 'popular-areas-central-coast',
        description: 'Includes Gosford, Erina, Tuggerah.',
        searchLocations: [
          'Central Coast, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-metro/QLD-Metro_InnerBrisbane',
        title: 'Inner Brisbane',
        omnitureItemId: 'popular-areas-inner-brisbane',
        description: 'Includes Brisbane, East Brisbane, Fortitude Valley.',
        searchLocations: [
          'Brisbane - Inner City Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/wa/WA_Perth',
        title: 'Inner Perth',
        omnitureItemId: 'popular-areas-inner-perth',
        description: 'Includes Perth, Subiaco, West Perth.',
        searchLocations: [
          'Perth City, WA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/sa/SA_InnerAdelaide',
        title: 'Inner Adelaide',
        omnitureItemId: 'popular-areas-inner-adelaide',
        description: 'Includes Adelaide, King William St, North Adelaide.',
        searchLocations: [
          'City, SA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-regional/QLD-regional_GoldCoast',
        title: 'Gold Coast',
        omnitureItemId: 'popular-areas-gold-coast',
        description: 'Includes Surfers Paradise, Southport, Broadbeach.',
        searchLocations: [
          'Gold Coast, QLD',
        ],
      },
    ],
  },
};
const VIC = {
  id: 'VIC',
  title: 'VIC',
  items: {
    metro: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-metro/VIC_Metro_Northern-Melbourne_Brunswick',
        title: 'Northern Melbourne',
        omnitureItemId: 'vic-northern-melbourne',
        description: 'Includes Campbelfield, Brunswick, Thomastown.',
        searchLocations: [
          'Melbourne - Northern Region, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-metro/VIC_Metro_Knox-City',
        title: 'Knox City',
        omnitureItemId: 'vic-knox-city',
        description: 'Includes Bayswater, Knoxfield, Scoresby.',
        searchLocations: [
          'Knox City - Region, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-metro/VIC_Metro_Inner-Melbourne_CBD',
        title: 'Inner Melbourne',
        omnitureItemId: 'vic-inner-melbourne',
        description: 'Includes Melbourne, Richmond, Port Melbourne.',
        searchLocations: [
          'Melbourne City - Greater Region, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-metro/VIC_Metro_South-East-Melbourne_Pakenham',
        title: 'South Eastern Melbourne',
        omnitureItemId: 'vic-south-eastern-melbourne',
        description: 'Includes Dandenong, Pakenham, Clayton.',
        searchLocations: [
          'South East Melbourne, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-metro/VIC_Metro_Eastern-Melbourne',
        title: 'Eastern Melbourne',
        omnitureItemId: 'vic-eastern-melbourne',
        description: 'Includes Bayswater, Knoxfield, Ringwood.',
        searchLocations: [
          'Eastern Melbourne, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-metro/VIC_Metro_Inner-East-Melbourne_South-Yarra',
        title: 'Inner Eastern Melbourne',
        omnitureItemId: 'vic-inner-eastern-melbourne',
        description: 'Includes Richmond, South Yarra, Hawthorn.',
        searchLocations: [
          'Inner East Melbourne, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-metro/VIC_Metro_Western-Melbourne_Footscray',
        title: 'Western Melbourne',
        omnitureItemId: 'vic-western-melbourne',
        description: 'Includes Footscray, Truganina, Ravenhall.',
        searchLocations: [
          'Western Melbourne, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-metro/VIC_Metro_Bayside',
        title: 'Bayside',
        omnitureItemId: 'vic-bayside',
        description: 'Includes Brighton, Moorabbin, Oakleigh.',
        searchLocations: [
          'Bayside, VIC',
        ],
      },
    ],
    regional: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-reginal/VIC_Regional_Western-Region',
        title: 'Western Victoria',
        omnitureItemId: 'vic-western-victoria',
        description: 'Includes Melton, Ballarat, Grampians, Horsham.',
        searchLocations: [
          'Western Region, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-reginal/VIC_Regional_Northern-Victoria',
        title: 'Northern Victoria',
        omnitureItemId: 'vic-northern-victoria',
        description: 'Includes Bendigo, Mildura, Echuca, Castlemaine.',
        searchLocations: [
          'Northern Region, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-reginal/VIC_Regional_Gippsland',
        title: 'Gippsland',
        omnitureItemId: 'vic-gippsland',
        description: 'Includes Warragul, Traralygon, Bairnsdale, Lakes Entrance.',
        searchLocations: [
          'Gippsland, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-reginal/VIC_Regional_Mornington-Peninsula',
        title: 'Mornington Peninsula',
        omnitureItemId: 'vic-mornington-peninsula',
        description: 'Includes Frankston, Mornington, Hastings, Rosebud.',
        searchLocations: [
          'Mornington Peninsula, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-reginal/VIC_Regional_North-Eastern-Victoria',
        title: 'North Eastern Victoria',
        omnitureItemId: 'vic-north-eastern-victoria',
        description: 'Includes Yarra Valley, Shepparton, Wangaratta, High Country.',
        searchLocations: [
          'North East Region, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-reginal/VIC_Regional_Geelong&Bellarine',
        title: 'Geelong and the Bellarine',
        omnitureItemId: 'vic-geelong-and-the-bellarine',
        description: 'Includes Geelong, Point Lonsdale, Barwon Heads, Queenscliff.',
        searchLocations: [
          'Bellarine Peninsula, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-reginal/VIC_Regional_Phillip-Island',
        title: 'Phillip Island',
        omnitureItemId: 'vic-phillip-island',
        description: 'Includes Cowes, Rhyll, San Remo, Newhaven.',
        searchLocations: [
          'Phillip Island, VIC',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/vic-reginal/VIC_Regional_South-Western-Victoria',
        title: 'South Western Victoria',
        omnitureItemId: 'vic-south-western-victoria',
        description: 'Includes Great Ocean Road, Colac, Hamilton.',
        searchLocations: [
          'South Western Region, VIC',
        ],
      },
    ],
  },
};
const NSW = {
  id: 'NSW',
  title: 'NSW',
  items: {
    metro: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-metro/nsw_metro_innerwestsydney_balmain',
        title: 'Inner West Sydney',
        omnitureItemId: 'nsw-inner-west-sydney',
        description: 'Includes Balmain, Camperdown, Marrickville.',
        searchLocations: [
          'Inner West, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-metro/nsw_metro_westernsydney',
        title: 'Western Sydney',
        omnitureItemId: 'nsw-western-sydney',
        description: 'Includes Blacktown, Arndell Park, Penrith.',
        searchLocations: [
          'Western Suburbs, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-metro/nsw_metro_parramatta',
        title: 'Parramatta & Surrounds',
        omnitureItemId: 'nsw-parramatta-and-surrounds',
        description: 'Includes Parramatta, Auburn, Yennora.',
        searchLocations: [
          'Parramatta - Greater Region, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-metro/nsw_metro_sutherlandshire',
        title: 'Sutherland Shire',
        omnitureItemId: 'nsw-sutherland-shire',
        description: 'Includes Caringbah, Cronulla, Miranda.',
        searchLocations: [
          'Sutherland Shire, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-metro/nsw_metro_northernbeaches',
        title: 'Northern Beaches',
        omnitureItemId: 'nsw-northern-beaches',
        description: 'Includes Manly, Brookvale, Frenchs Forest.',
        searchLocations: [
          'Northern Beaches, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-metro/nsw_metro_penrith',
        title: 'Penrith & Surrounds',
        omnitureItemId: 'nsw-penrith-and-surrounds',
        description: 'Includes Penrith, Emu Plains, Kingswood.',
        searchLocations: [
          'Penrith - Greater Region, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-metro/nsw_metro_easternsuburbs_pyrmont',
        title: 'Eastern Suburbs',
        omnitureItemId: 'nsw-eastern-suburbs',
        description: 'Includes Surry Hills, Pyrmont, Potts Point.',
        searchLocations: [
          'Eastern Suburbs, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-metro/nsw_metro_uppernorthshore',
        title: 'Upper North Shore',
        omnitureItemId: 'nsw-upper-north-shore',
        description: 'Includes Gladesville, Macquarie Park, North Ryde.',
        searchLocations: [
          'Upper North Shore, NSW',
        ],
      },
    ],
    regional: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-regional/nsw_regional_centralcoast_gosford',
        title: 'Central Coast',
        omnitureItemId: 'nsw-central-coast',
        description: 'Includes Gosford, Erina, Tuggerah.',
        searchLocations: [
          'Central Coast, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-regional/nsw_regional_newcastle',
        title: 'Newcastle & Surrounds',
        omnitureItemId: 'nsw-newcastle-and-surrounds',
        description: 'Includes Newcastle, Charlestown, Cardiff.',
        searchLocations: [
          'Newcastle - Greater Region, NSW',
          'Charlestown, NSW 2290',
          'Warners Bay, NSW 2282',
          'Cardiff, NSW 2285',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-regional/nsw_regional_hunterregion',
        title: 'Hunter Region',
        omnitureItemId: 'nsw-hunter-region',
        description: 'Includes Newcastle, Maitland, Cessnock.',
        searchLocations: [
          'Hunter Region, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-regional/nsw_regional_wollongong',
        title: 'Wollongong & Surrounds',
        omnitureItemId: 'nsw-wollongong-and-surrounds',
        description: 'Includes Wollongong, Unanderra, Kembla Range.',
        searchLocations: [
          'Wollongong - Greater Region, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-regional/nsw_regional_southcoast_wollongong',
        title: 'South Coast',
        omnitureItemId: 'nsw-south-coast',
        description: 'Includes Port Kembla, Ulladulla, Batemans Bay.',
        searchLocations: [
          'South Coast, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-regional/nsw_regional_waggawagga',
        title: 'Wagga Wagga & Surrounds',
        omnitureItemId: 'nsw-wagga-wagga-and-surrounds',
        description: 'Includes Wagga Wagga, Albury, Deniliquin.',
        searchLocations: [
          'Wagga Wagga - Greater Region, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-regional/nsw_regional_byronbay',
        title: 'Byron Bay & Ballina',
        omnitureItemId: 'nsw-byron-bay-and-ballina',
        description: 'Includes Byron Bay, Ballina.',
        searchLocations: [
          'Byron Bay - Greater Region, NSW',
          'Ballina - Greater Region, NSW',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nsw-regional/nsw_regional_illawarra',
        title: 'Illawarra & Surrounds',
        omnitureItemId: 'nsw-illawarra-and-surrounds',
        description: 'Includes Wollongong, Fairy Meadow, Shellharbour.',
        searchLocations: [
          'Illawarra Region, NSW',
        ],
      },
    ],
  },
};
const QLD = {
  id: 'QLD',
  title: 'QLD',
  items: {
    metro: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-metro/QLD-Metro_InnerBrisbane',
        title: 'Inner Brisbane',
        omnitureItemId: 'qld-inner-brisbane',
        description: 'Includes Brisbane, East Brisbane, Fortitude Valley.',
        searchLocations: [
          'Brisbane - Inner City Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-metro/QLD-Metro_northernbrisbane',
        title: 'Northern Brisbane',
        omnitureItemId: 'qld-northern-brisbane',
        description: 'Includes Northgate, Brendale, North Lakes.',
        searchLocations: [
          'Brisbane - Northern Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-metro/qld_southern_brisbane',
        title: 'Southern Brisbane',
        omnitureItemId: 'qld-southern-brisbane',
        description: 'Includes Rocklea, Mansfield, Slacks Creek.',
        searchLocations: [
          'Brisbane - Southern Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-metro/QLD-Metro_EasternBrisbane',
        title: 'Eastern Brisbane',
        omnitureItemId: 'qld-eastern-brisbane',
        description: 'Includes East Brisbane, Morningside, Tingalpa.',
        searchLocations: [
          'Brisbane - Eastern Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-metro/qld_western_brisbane',
        title: 'Western Brisbane',
        omnitureItemId: 'qld-western-brisbane',
        description: 'Includes Red Hill, Sumner, Richlands.',
        searchLocations: [
          'Brisbane - Western Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-metro/QLD-Metro_Brisbane_WestEnd',
        title: 'Brisbane & Surrounds',
        omnitureItemId: 'qld-brisbane-and-surrounds',
        description: 'Includes Fortitude Valley, Eagle Farm, West End.',
        searchLocations: [
          'Brisbane - Greater Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-metro/qld_logan_city',
        title: 'Logan City & Surrounds',
        omnitureItemId: 'qld-logan-city-and-surrounds',
        description: 'Includes Slacks Creek, Crestmead, Loganholme.',
        searchLocations: [
          'Logan City - Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-metro/QLD-Metro_MortonBay_Caboolture',
        title: 'Moreton Bay & Surrounds',
        omnitureItemId: 'qld-moreton-bay-and-surrounds',
        description: 'Includes Caboolture, North Lakes, Clontarf.',
        searchLocations: [
          'Moreton Bay Region, QLD',
        ],
      },
    ],
    regional: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-regional/QLD-regional_GoldCoast',
        title: 'Gold Coast',
        omnitureItemId: 'qld-gold-coast',
        description: 'Includes Surfers Paradise, Southport, Burleigh Heads.',
        searchLocations: [
          'Gold Coast, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-regional/QLD-regional_sunshinecoast',
        title: 'Sunshine Coast',
        omnitureItemId: 'qld-sunshine-coast',
        description: 'Includes Noosaville, Maroochydore, Caloundra.',
        searchLocations: [
          'Sunshine Coast, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-regional/QLD-regional_Townsville',
        title: 'Townsville',
        omnitureItemId: 'qld-townsville',
        description: 'Includes Townsville City, Currajong, Garbutt.',
        searchLocations: [
          'Townsville - Greater Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-regional/QLD-regional_Cairns',
        title: 'Cairns',
        omnitureItemId: 'qld-cairns',
        description: 'Includes Cairns, Earlville, Smithfield.',
        searchLocations: [
          'Cairns - Greater Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-regional/QLD-regional_Rockhampton',
        title: 'Rockhampton',
        omnitureItemId: 'qld-rockhampton',
        description: 'Includes Rockhampton, Berserker, Gracemere.',
        searchLocations: [
          'Rockhampton - Greater Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-regional/QLD-regional_Toowoomba',
        title: 'Toowoomba',
        omnitureItemId: 'qld-toowoomba',
        description: 'Includes Toowoomba, Torrington.',
        searchLocations: [
          'Toowoomba - Greater Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-regional/QLD-regional_Mackay',
        title: 'Mackay',
        omnitureItemId: 'qld-mackay',
        description: 'Includes Mackay, Paget, Mackay Harbour.',
        searchLocations: [
          'Mackay - Greater Region, QLD',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/qld-regional/QLD-regional_Ipswich',
        title: 'Ipswich',
        omnitureItemId: 'qld-ipswich',
        description: 'Includes Ipswich, Raceview, Carole Park.',
        searchLocations: [
          'Ipswich - Greater Region, QLD',
        ],
      },
    ],
  },
};
const SA = {
  id: 'SA',
  title: 'SA',
  items: {
    any: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/sa/SA_InnerAdelaide',
        title: 'Inner Adelaide',
        omnitureItemId: 'sa-inner-adelaide',
        description: 'Includes Adelaide, King William St, North Adelaide.',
        searchLocations: [
          'City, SA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/sa/SA_EasternAdelaide',
        title: 'Eastern Adelaide',
        omnitureItemId: 'sa-eastern-adelaide',
        description: 'Includes Norwood, Wayville, Kent Town.',
        searchLocations: [
          'Eastern Adelaide, SA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/sa/SA_NothernAdelaide',
        title: 'Northern Adelaide',
        omnitureItemId: 'sa-northern-adelaide',
        description: 'Includes Mawson Lakes, Salisbury, Edinburgh.',
        searchLocations: [
          'Northern Adelaide, SA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/sa/SA_WesternAdelaide',
        title: 'Western Adelaide',
        omnitureItemId: 'sa-western-adelaide',
        description: 'Includes Wingfield, Port Adelaide, Beverley.',
        searchLocations: [
          'Western Adelaide, SA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/sa/SA_SouthernAdelaide',
        title: 'Southern Adelaide',
        omnitureItemId: 'sa-southern-adelaide',
        description: 'Includes Edwardstown, Glenelg, Lonsdale.',
        searchLocations: [
          'Southern Adelaide, SA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/sa/SA_MountGambier',
        title: 'Mount Gambier',
        omnitureItemId: 'sa-mount-gambier',
        description: 'Includes Mount Gambier, Port Macdonnell.',
        searchLocations: [
          'Mount Gambier - Greater Region, SA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/sa/SA_AdelaideHills',
        title: 'Adelaide Hills',
        omnitureItemId: 'sa-adelaide-hills',
        description: 'Includes Mount Barker, Meadows, Murray Bridge.',
        searchLocations: [
          'Adelaide Hills, SA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/sa/SA_BarossaValley',
        title: 'Barossa Valley',
        omnitureItemId: 'sa-barossa-valley',
        description: 'Includes Tanunda, Nuriootpa.',
        searchLocations: [
          'Barossa Valley- Greater Region, SA',
        ],
      },
    ],
  },
};
const ACT = {
  id: 'ACT',
  title: 'ACT',
  items: {
    any: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/act/act_canberra',
        title: 'Canberra',
        omnitureItemId: 'act-canberra',
        description: 'Includes Canberra, Fyshwick, Mitchell.',
        searchLocations: [
          'Canberra - Greater Region, ACT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/act/act_inner_regions_kingston',
        title: 'Inner Regions',
        omnitureItemId: 'act-inner-regions',
        description: 'Includes Barton, Braddon, Kingston.',
        searchLocations: [
          'Inner North, ACT',
          'Inner South, ACT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/act/act_gungahlin_district',
        title: 'Gungahlin District',
        omnitureItemId: 'act-gungahlin-district',
        description: 'Includes Mitchell, Gungahlin, Nicholls.',
        searchLocations: [
          'Gungahlin District, ACT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/act/act_woden_valley',
        title: 'Woden Valley District',
        omnitureItemId: 'act-woden-valley-district',
        description: 'Includes Phillip, Mawson, Garran.',
        searchLocations: [
          'Woden Valley District, ACT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/act/act_tuggeranong',
        title: 'Tuggeranong District',
        omnitureItemId: 'act-tuggeranong-district',
        description: 'Includes Tuggeranong, Greenway, Wanniassa.',
        searchLocations: [
          'Tuggeranong District, ACT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/act/act_belconnen',
        title: 'Belconnen District',
        omnitureItemId: 'act-belconnen-district',
        description: 'Includes Belconnen, Holt, Bruce.',
        searchLocations: [
          'Belconnen District, ACT',
        ],
      },
    ],
  },
};
const WA = {
  id: 'WA',
  title: 'WA',
  items: {
    any: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/wa/WA_Perth',
        title: 'Inner Perth',
        omnitureItemId: 'wa-inner-perth',
        description: 'Includes Perth, Subiaco, West Perth.',
        searchLocations: [
          'Perth City, WA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/wa/WA_South-West-Perth',
        title: 'South Western Perth',
        omnitureItemId: 'wa-south-western-perth',
        description: 'Includes Fremantle, Canning Vale, Rockingham.',
        searchLocations: [
          'South West Perth, WA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/wa/wa_south_east_perth',
        title: 'South Eastern Perth',
        omnitureItemId: 'wa-south-eastern-perth',
        description: 'Includes Belmont, Welshpool, Maddington.',
        searchLocations: [
          'South East Perth, WA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/wa/wa_northern_perth',
        title: 'Northern Perth',
        omnitureItemId: 'wa-northern-perth',
        description: 'Includes Osborne Park, Malaga, Wangara.',
        searchLocations: [
          'North East Perth, WA',
          'North West Perth, WA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/wa/WA_Northern-Region',
        title: 'Northern WA',
        omnitureItemId: 'wa-northern-wa',
        description: 'Includes Carnarvon, Karratha, Broome.',
        searchLocations: [
          'Northern Region, WA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/wa/WA_South-Coast-Region',
        title: 'South Coast',
        omnitureItemId: 'wa-south-coast',
        description: 'Includes Port Kennedy, Greenfields, Margaret River.',
        searchLocations: [
          'South Coast Region, WA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/wa/WA_Geraldton-Greater-Region',
        title: 'Geraldton & Surrounds',
        omnitureItemId: 'wa-geraldton-and-surrounds',
        description: 'Includes Geraldton, Webberton, Narngulu.',
        searchLocations: [
          'Geraldton - Greater Region, WA',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/wa/WA_Kalgoorlie-Bolder-Region',
        title: 'Kalgoorlie-Boulder Region',
        omnitureItemId: 'wa-kalgoorlie-boulder-region',
        description: 'Includes Kalgoorlie, West Kalgoorlie, Boulder.',
        searchLocations: [
          'Kalgoorlie-Boulder Region, WA',
        ],
      },
    ],
  },
};
const NT = {
  id: 'NT',
  title: 'NT',
  items: {
    any: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nt/NT_Darwin_Greaterregion',
        title: 'Darwin & Surrounds',
        omnitureItemId: 'nt-darwin-and-surrounds',
        description: 'Includes Darwin, Winnellie, Parrap.',
        searchLocations: [
          'Darwin - Greater Region, NT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nt/nt_palmerston',
        title: 'Palmerston & Surrounds',
        omnitureItemId: 'nt-palmerston-and-surrounds',
        description: 'Includes Palmerston, Pinelands, Yarrawonga.',
        searchLocations: [
          'Palmerston - Greater Region, NT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nt/nt_southern_nt',
        title: 'Southern NT',
        omnitureItemId: 'nt-southern-nt',
        description: 'Includes Tennant Creek, Ciccone.',
        searchLocations: [
          'Southern Region, NT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nt/NT_NorthernRegion_Katherine',
        title: 'Northern NT',
        omnitureItemId: 'nt-northern-nt',
        description: 'Includes Humpty Doo, Katherine.',
        searchLocations: [
          'Northern Region, NT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nt/NT_AliceSprings',
        title: 'Alice Springs',
        omnitureItemId: 'nt-alice-springs',
        description: 'Includes Alice Springs, Ciccone.',
        searchLocations: [
          'Alice Springs - Greater Region, NT',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/nt/NT_Darwin',
        title: 'Inner Darwin',
        omnitureItemId: 'nt-inner-darwin',
        description: 'Includes Darwin City, Parrap, Woolner.',
        searchLocations: [
          'Darwin, NT',
        ],
      },
    ],
  },
};
const TAS = {
  id: 'TAS',
  title: 'TAS',
  items: {
    any: [
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/tas/TAS-Hobart_GreaterRegion',
        title: 'Hobart & Surrounds',
        omnitureItemId: 'tas-hobart-and-surrounds',
        description: 'Includes Hobart, Glenorchy, Cambridge.',
        searchLocations: [
          'Hobart - Greater Region, TAS',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/tas/TAS-Devonport_GreaterRegion',
        title: 'Devonport & Surrounds',
        omnitureItemId: 'tas-devonport-and-surrounds',
        description: 'Includes Devonport, Sheffield, Port Sorrell.',
        searchLocations: [
          'Devonport - Greater Region, TAS',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/tas/TAS_Launceston_Greater-Region',
        title: 'Launceston & Surrounds',
        omnitureItemId: 'tas-launceston-and-surrounds',
        description: 'Includes Launceston, King Meadows, Western Junction.',
        searchLocations: [
          'Launceston - Greater Region, TAS',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/tas/TAS_East-Coast-Region',
        title: 'East Coast',
        omnitureItemId: 'tas-east-coast',
        description: 'Includes Port Arthur, Swansea, Bicheno.',
        searchLocations: [
          'Tasmania - East Coast Region, TAS',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/tas/TAS-Burnie_GreaterRegion',
        title: 'Burnie',
        omnitureItemId: 'tas-burnie',
        description: 'Includes Burnie, Wivenhoe, Somerset.',
        searchLocations: [
          'Burnie - Greater Region, TAS',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/tas/TAS_West-Coast',
        title: 'West Coast',
        omnitureItemId: 'tas-west-coast',
        description: 'Includes Stanley, Queenstown, Strahan.',
        searchLocations: [
          'West Coast, TAS',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/tas/TAS-HuonValley',
        title: 'Huon Valley',
        omnitureItemId: 'tas-huon-valley',
        description: 'Includes Huonville, Gardeners Bay, Dover.',
        searchLocations: [
          'Huon Valley, TAS',
        ],
      },
      {
        bgImg: '/listing-ui-assets/img/homepage/explore-region/tas/TAS_Midlands',
        title: 'Midlands',
        omnitureItemId: 'tas-midlands',
        description: 'Includes Western Junction, Longford, Campbell Town.',
        searchLocations: [
          'Midlands, TAS',
        ],
      },
    ],
  },
};

export const ALL_AREAS = {
  ALL_STATES,
  POPULAR_AREAS,
  VIC,
  NSW,
  QLD,
  WA,
  SA,
  TAS,
  ACT,
  NT,
};

export const getItemsForArea = currentArea =>
  get(ALL_AREAS, `${currentArea}.items`, []);

export const getItemsForButtons = () =>
  map(ALL_AREAS, area => pick(area, ['id', 'title']));

export const getItemsForToggle = currentArea => keysIn(getItemsForArea(currentArea));

export const getAreaAndRegionItems = () =>
  flatMap(
    ALL_AREAS,
    ({ items, title, id }) => (
      map(items, (value, regionKey) => ({
        displayText: regionKey === 'any' ? title : `${title} - ${upperFirst(regionKey)}`,
        value: {
          areaId: id,
          regionId: regionKey,
        },
      }))
    ),
  );

export const getCurrentAreaAndRegionItem = (areaAndRegionItems, currentArea, currentRegion) => (
  find(
    areaAndRegionItems,
    ({ value: { areaId, regionId } }) => areaId === currentArea && regionId === currentRegion,
  )
);
